// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".84e51db6c5de0b1c632a2a4e0104b054.js";
};